import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type AccountStatusName =
    | 'None'
    | 'Pending'
    | 'KycDeclined'
    | 'KycVerified'
    | 'Complete';

export interface DebugRootState {
    changeDebugAccountStatus: boolean;
    debugAccountStatus: AccountStatusName;
}

const initialState: DebugRootState = {
    changeDebugAccountStatus: false,
    debugAccountStatus: 'None',
};

const debugSlice = createSlice({
    name: 'debug',
    initialState: initialState,
    reducers: {
        setAccountStatus: (state, action: PayloadAction<DebugRootState>) => {
            return { ...state, ...action.payload };
        },
    },
});

export const { setAccountStatus } = debugSlice.actions;
export const debugReducer = debugSlice.reducer;
export const selectDebugState = (state: { debug: DebugRootState }) =>
    state.debug;
